import React, { useEffect } from 'react';
import ProductGridWithFilters from '~/components/collection/ProductGridWithFilters';
import { productFragment } from '~/utils/queries';
import { useParams as useUrl } from 'react-router-dom';
import webstoreTracker, {
  ContentGroups,
} from '~/helpers/trackers/webstoreTrackerWrapper';

interface RouteParams {
  slug: string;
}

// These filters form the basis of all product requests (on initial page load
// and also on changes to filters or pagination)
const queryFilters =
  '$itemsPerPage: Int!, $page: Int!, $slug: String!, $order: ProductOrder';
const productsFilters = 'first: $itemsPerPage, page: $page, order: $order';

// This query gets pagination and product data it should be nested within a
// call to the products resource
const productsQuery = `
  paginatorInfo {
    count
    total
    currentPage
    lastPage
  }
  data {
    ${productFragment}
  }
`;

// This query gets all secondary collection page states (on changes to filters
// or pagination)
const collectionQuery = `
  query(${queryFilters}) {
    collection(slug: $slug) {
      products(${productsFilters}) {
        ${productsQuery}
      }
    }
  }
`;

const Collection = () => {
  const { slug } = useUrl<RouteParams>();

  useEffect(() => {
    webstoreTracker.tagGroup(ContentGroups.CollectionPage);
  }, []);

  const variables = {
    slug,
  };
  return (
    <ProductGridWithFilters
      // If the slug changes, we want to completely teardown this component
      // so it starts fresh on page 1, reset filters, etc., treating it like
      // a page change. We can do that with "key."
      key={slug}
      query={collectionQuery}
      variables={variables}
      queryFilters={queryFilters}
      productsFilters={productsFilters}
      requestType="collectionPage"
      collectionSlug={slug}
    />
  );
};

export default Collection;
